import React, { useState, useEffect } from "react";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";

function OptionM({ onInputChange, year, month, tomonth, toyear }) {
  const today = new Date();
  //const Datemax =
  //  today.getMonth() === 0
  //    ? today.getFullYear() - 1 + "-" + 12
  //          : today.getFullYear() + "-" + today.getMonth();
  const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

  const initialValue = tomonth && toyear
    ? dayjs(`${toyear}-${tomonth}-01`)
    : (month === 0 || year === 0
        ? dayjs(`${today.getFullYear()}-${today.getMonth() + 1}-01`)
        : dayjs(`${year}-${month}-01`)
      );

  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (tomonth && toyear) {
      setValue(dayjs(`${toyear}-${tomonth}-01`));
      }
      
  }, [tomonth, toyear]);

  //console.log("Value: ", value);

  const handleDateChange = (newValue) => {
    const newMonth = newValue.$M + 1;
    const newYear = newValue.$y;

    // Store in sessionStorage
    sessionStorage.setItem("CurrentMonth2", newMonth);
    sessionStorage.setItem("CurrentYear2", newYear);

    onInputChange(newMonth, newYear);

    setValue(newValue);
  };


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={3}>
        <MobileDatePicker
          disableFuture
          label="Select Month and Year"
          openTo="year"
          views={["year", "month"]}
          value={value}
          onChange={handleDateChange}  // Use the custom handler here
          minDate={dayjs(`${year}-${month}-01`)}
          maxDate={dayjs(lastMonth)}
          renderInput={(params) => (
            <TextField
              sx={{ width: 200 }}
              onKeyDown={(evt) => evt.preventDefault()}
              {...params}
            />
          )}
        />
      </Stack>
    </LocalizationProvider>
  );
}

export default OptionM;
